import { AuthDto } from './dtos/auth.dto';
import { axiosCore } from './http-core-service';

/**
 * Méthode d'appel au back pour la récupération du token de connexion
 *
 * @param auth
 */
export const login = async (auth: AuthDto) => {
    const data = { username: auth.login, password: auth.password };
    const response = await axiosCore.post('/api/login_check', data);
    return response.data.token;
};

/**
 * Récupération du token d'un user
 * @param id identifiant du compte
 */
export const getUserToken = async (id: string): Promise<string> => {
    const response = await axiosCore.get(`api/users/${id}/generate_token`);
    return response.data.token;
};

/**
 * Méthode d'appel au back pour l'envoie d'un mail en cas de mot de passe perdu
 *
 * @param email
 */
export const sendPasswordRetrieveRequest = async (email: string) => {
    const data = { email: email };
    const response = await axiosCore.patch(`/api/users/reset_password`, data);
    return response.data;
};
